import styled from 'styled-components';

export const Card = styled.div`
  border-radius: 1.2rem;
  padding: 2.4rem;

  display: flex;
  align-items: center;
  justify-content: space-between;

  &.solid {
    background: linear-gradient(90deg, rgba(30, 30, 39, 0) 0%, rgba(30, 30, 39, 0.3) 51.87%, rgba(30, 30, 39, 0) 100%);
  }
  &.outline {
    border: .1rem solid ${(props) => props.theme.colors.darkBlue};
  }
`;

export const Info = styled.div`
  display: flex;
  gap: 3.2rem;
`;

export const Seporator = styled.div`
  width: .1rem;
  background: ${(props) => props.theme.colors.darkBlue};
`;

export const Actions = styled.div`
  display: flex;
  gap: .8rem;
  margin-left: 4.8rem;
`;